import axiosInstance from '../helpers/axios';

/** /api/ops/calendar-sync — Outlook ↔ portal: classes out, busy time in. */

export type TCalendarSyncRun = {
  at: string;
  mode: string;
  ok: boolean;
  ms?: number;
  error?: string;
  outbound?: {
    create: number;
    update: number;
    remove: number;
    unchanged: number;
    applied: boolean;
  };
  inbound?: {
    insert: number;
    update: number;
    remove: number;
    unchanged: number;
    applied: boolean;
    users: number;
  };
  unmapped?: { name: string; classes: number }[];
  userErrors?: { email: string; error: string }[];
  teachingDropped?: number;
};

export type TCalendarSyncStatus = {
  mode: 'off' | 'record' | 'live';
  scope: 'local' | 'all';
  horizonDays: number;
  allowlist: string[];
  blockShowAs: string[];
  tenantDomains: string[];
  configured: boolean;
  missing: string[];
  counts: {
    events: number;
    blocks: number;
    instructors: number;
    instructorsWithEmail: number;
    instructorsOutsideTenant: number;
  };
  instructorsWithoutEmail: { id: string; displayName: string }[];
  instructorsOutsideTenant: {
    id: string;
    displayName: string;
    email: string;
  }[];
  lastRun: TCalendarSyncRun | null;
  runs: TCalendarSyncRun[];
};

export type TCalendarSyncPlan = {
  ran: boolean;
  reason?: string;
  run?: TCalendarSyncRun;
  plan?: {
    events: {
      create: {
        classId: string;
        instructor: string;
        subject: string;
        start: string;
      }[];
      update: {
        classId: string;
        instructor: string;
        subject: string;
        start: string;
      }[];
      remove: { classId: string; instructor: string; eventId: string }[];
    };
    blocks: {
      insert: {
        instructorId: string;
        from: string;
        to: string;
        note: string;
      }[];
      update: { id: string; from: string; to: string }[];
      remove: string[];
    };
  };
};

export const getCalendarSyncStatus = async () =>
  (await axiosInstance.get<TCalendarSyncStatus>('ops/calendar-sync/status'))
    .data;

export const planCalendarSync = async () =>
  (await axiosInstance.post<TCalendarSyncPlan>('ops/calendar-sync/plan')).data;

export const runCalendarSync = async () =>
  (await axiosInstance.post<TCalendarSyncPlan>('ops/calendar-sync/run')).data;
